import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";

export default function WhatsAppFloat() {
  const { t } = useLanguage();
  const [wa, setWa] = useState("");
  useEffect(() => {
    publicApi.config().then((c) => setWa(c.whatsapp || "")).catch(() => {});
  }, []);
  if (!wa) return null;
  const msg = encodeURIComponent(t("contact.whatsapp_prefill"));
  return (
    <a
      href={`https://wa.me/${wa}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-ink text-bg pl-3 pr-4 py-3 shadow-lg border border-ink/10 hover:bg-accent hover:text-white transition-colors"
      style={{ transitionProperty: "background-color, color" }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </svg>
      <span className="text-xs tracking-wide uppercase font-medium">WhatsApp</span>
    </a>
  );
}
